import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store"
import HomeView from '../views/HomeView.vue'
import MainLayout from '@/layout/MainLayout.vue'
import Login from '@/layout/AuthLayout.vue'
import CampaignView from '@/views/CampaignView.vue'
import MeetingView from '@/views/meeting/MeetingView.vue'
import ValuePropositionView from '@/views/ValuePropositionView.vue'
import Callback from '@/layout/ApiAccessLayout.vue'
import SurveyView from '@/views/SurveyView.vue'
import SuggestionBoxView from '@/views/SuggestionBoxView.vue'
import InformationMailboxView from '@/views/InformationBoxView.vue'
import CardsView from '@/views/CardsView.vue'
import ReportsView from '@/views/ReportsView.vue'
import OrganizationChartView from '@/views/OrganizationChartView.vue'
import CarouselView from '@/views/CarouselView.vue'
import ClientsView from '@/views/ClientsView.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import ForgetPassword from '@/views/ForgetPassword.vue'
import ReportsSurvey from '@/views/ReportsSurvey.vue'
import ReportsMeeting from '@/views/ReportsMeeting.vue'
import ReportProposition from '@/views/ReportProposition.vue'
import ReportSuggestion from '@/views/ReportSuggestion.vue'
import ExternalSurveyPage from '@/components/ExternalSurveyPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/main',
    redirect: '/main/home',
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      roles: false
    }
  },
  {
    path: '/forget/password',
    name: 'forget',
    component: ForgetPassword,
    meta: {
      roles: false
    }
  },
  {
    path: '/reset/password',
    name: 'reset',
    component: ResetPassword,
    meta: {
      roles: false
    }
  },
  {
    path: '/callback',
    name: 'callback',
    component: Callback,
    meta: {
      roles: false
    }
  },
  {
    path: '/evaluar-reunion',
    name: 'ExternalSurvey',
    component: ExternalSurveyPage,
    meta: {
      roles: false
    }
  },
  {
    path: '/main',
    name: 'main',
    component: MainLayout,
    children: [
      {
        path: 'home',
        name: 'home',
        component: HomeView,
        meta: {
          roles: true
        }
      },
      {
        path: 'campaign',
        name: 'campaign',
        component: CampaignView,
        meta: {
          roles: true
        }
      },
      {
        path: 'meeting',
        name: 'meeting',
        component: MeetingView,
        meta: {
          roles: true
        }
      },
      {
        path: 'proposition',
        name: 'proposition',
        component: ValuePropositionView,
        meta: {
          roles: true
        }
      },
      {
        path: 'survey',
        name: 'survey',
        component: SurveyView,
        meta: {
          roles: true
        }
      },
      {
        path: 'suggestionbox',
        name: 'suggestionbox',
        component: SuggestionBoxView,
        meta: {
          roles: true
        }
      },
      {
        path: 'informationbox',
        name: 'informationbox',
        component: InformationMailboxView,
        meta: {
          roles: true
        }
      },
      {
        path: 'cards',
        name: 'cards',
        component: CardsView,
        meta: {
          roles: true
        }
      },
      {
        path: 'chart',
        name: 'chart',
        component: OrganizationChartView,
        meta: {
          roles: true
        }
      },
      {
        path: 'carrousel',
        name: 'carrousel',
        component: CarouselView,
        meta: {
          roles: true
        }
      },
      {
        path: 'clients',
        name: 'clients',
        component: ClientsView,
        meta: {
          roles: true
        }
      },
      {
        path: 'reports/minuta',
        name: 'reports/minuta',
        component: ReportsView,
        meta: {
          roles: true
        }
      },
      {
        path: 'reports/survey',
        name: 'reports/survey',
        component: ReportsSurvey,
        meta: {
          roles: true
        }
      },
      {
        path: 'reports/meeting',
        name: 'reports/meeting',
        component: ReportsMeeting,
        meta: {
          roles: true
        }
      },
      {
        path: 'reports/proposition',
        name: 'reports/proposition',
        component: ReportProposition,
        meta: {
          roles: true
        }
      },
      {
        path: 'reports/suggestionbox',
        name: 'reports/suggestionbox',
        component: ReportSuggestion,
        meta: {
          roles: true
        }
      },
      { path: '/:pathMatch(.*)*', redirect: '/' }

    ]
  }, {
    path: '*',
    redirect: '/main/home',
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const Auth = store.state.auth
  const needAuth = to.meta.roles
  if (needAuth && !Auth) {
    next({
      name: "login"
    })
  } else {
    next()
  }
})

export default router
